module.exports = __webpack_public_path__ + "static/media/icr_facility_ac.d1640eb2.png";